/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_DiscordInputs */



/**
* | output |
* | --- |
* | "Discord authentication error." |
*
* @param {Login_Error_DiscordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_error_discord = /** @type {((inputs?: Login_Error_DiscordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_DiscordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur d'authentification Discord.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de autenticación de Discord.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro de autenticação Discord.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore di autenticazione Discord.")
	return /** @type {LocalizedString} */ ("Discord authentication error.")
});